/**
 * 業務・業務ロジック（F3）の Query キー。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 業務・業務ロジック・業務ルールの読取 procedure の Query キーを定義する。
 * @graph-connects none
 */
import type { LocaleKeyPart } from './common.js';

/** 業務・業務ロジックの仕様グラフ読取のキー。 @graph-connects none */
export const businessLogicQueryKeys = {
  /*
   * 案件番号まで鍵に載せる。同じ業務を案件あり / なしで 2 回引いて突き合わせるので、載せないと
   * 後から引いた側が相手を上書きする。
   */
  getBusinessRules: (businessId: number, locale: LocaleKeyPart, pjNumber?: number) =>
    ['specGraph', 'getBusinessRules', businessId, pjNumber ?? null, locale ?? null] as const,
  /* 1 呼び出しで master と案件適用後の両方が返るので、面は載せない。 */
  getRule: (ruleId: number, locale: LocaleKeyPart, pjNumber?: number) =>
    ['specGraph', 'getRule', ruleId, pjNumber ?? null, locale ?? null] as const,
  /* 1 呼び出しで master と案件適用後の両方が返るので、面は載せない。 */
  getBusinessDetail: (businessId: number, locale: LocaleKeyPart, pjNumber?: number) =>
    ['specGraph', 'getBusinessDetail', businessId, pjNumber ?? null, locale ?? null] as const,
} as const;
